import React from 'react';
import { Link } from 'react-router-dom';
import '../../../public/scss/errorPage.scss';

const ErrorPage = () => {
    return (
        <div className="error-page">
            <div className="error-content">
                <div className="error-image">
                    {/* <div className="triangle" /> */}
                    <span />
                </div>
                <div className="error-desc">
                    <div>
                        <div className="content-1">
                            Please try again, an error has occured. If the issue continues, call
                            <a href="tel:800-323-3049"> 800-323-3049</a>
.
                        </div>
                        <div className="content-2">
                            You can navigate to the
                            <Link to="/"> Home page </Link>
                            or send
                            <a href="mailto:ABGHProviderDirectory@NGIC.COM"> email</a>
                            {' '}
for help.
                        </div>
                    </div>
                </div>
            </div>
            <div className="support-info">
                <div className="text--bold">
                    Have a question?
                    <br />
                    We&apos;re here to help.
                </div>
                <div>
                    Call us with questions at.
                    <br />
                    <a href="tel:800-323-3049">800-323-3049</a>
                </div>
                <div>
                    Monday through Friday
                    <br />
                    8 a.m. to 8 p.m. ET
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
